import { render, staticRenderFns } from "./DashboardOperations.vue?vue&type=template&id=df2b765c"
import script from "./DashboardOperations.vue?vue&type=script&lang=js"
export * from "./DashboardOperations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports